<template>
  <div>
    <b-button @click.prevent="$bvModal.show(id)">Incluir pallets</b-button>
    <b-modal :id="id" class="p-0" size="xl" @ok="handleOk" @show="clearPallets">
      <server-filterable-table
        :downloadeable="false"
        :column_display="column_display"
        :columns="columns"
        :filterable="filterable"
        :headings="headings"
        :listColumns="listColumns"
        :url="url"
        :clickable="true"
        :action-buttons="action_buttons"
        @on-loading="loading = $event"
        @on-plus-action="onSelectRow"
      />
      <b-form-group label="Motivo de ingreso" description="Responsable(Fecha): Motivo o explicación">
        <b-form-textarea v-model="motivo"></b-form-textarea>
      </b-form-group>
      Seleccionados: {{ itemList }} <br />
      <b-button variant="link" @click.prevent="clearPallets">Limpiar</b-button>
    </b-modal>
  </div>
</template>

<script>
import ServerFilterableTable from "@/bagno_views/ServerFilterableTable";
export default {
  name: "IncludePallets",
  components: {
    ServerFilterableTable
  },
  props: {
    id: {
      type: String,
      default: "include-pallets-modal"
    },
    sidePallets: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      motivo: null,
      items: [],
      selectedItems: [],
      url: "/api/v1/content/c_stock/?paginated=true&product_id=14",
      title: "Listado de Stock",
      loading: false,
      action_buttons: ["plus"],
      columns: [
        "id",
        "pallet_number",
        "product_type_name",
        "daystay",
        "variety_name",
        "condition",
        "origin_name",
        "classification",
        "actions"
      ],
      filterable: ["pallet_number", "variety_name", "origin_name", "classification", "condition", "product_type_name"],
      headings: { actions: "", classification: "QC" },
      listColumns: {}
    };
  },
  computed: {
    itemList() {
      return this.selectedItems.map((item) => item.pallet_number).join(", ");
    }
  },
  methods: {
    clearPallets() {
      this.selectedItems = [];
    },
    handleShow() {
      const sidePalletsKeys = Object.keys(this.sidePallets);
      if (sidePalletsKeys.length > 0) {
        this.selectedItems = this.sidePallets["pallets"];
        this.motivo = this.sidePallets["motivo"];
      } else {
        this.selectedItems = [];
        this.motivo = null;
      }
    },
    handleOk() {
      const payload = {
        pallets: this.selectedItems,
        motivo: this.motivo
      };
      this.$emit("ok", payload);
    },
    onSelectRow(row) {
      if (!this.selectedItems.find((item) => item.id === row.id)) {
        this.selectedItems.push(row);
      }
    },
    debug(eve) {
      console.log(eve);
    }
  }
};
</script>

<style></style>
